import { Record } from "immutable";

import createFromJS from "../../createFromJS";

// Model Immutable Records
export const InsetRecord = Record({
  left: 0, //44, // use for testing in browser
  right: 0, //44, // use for testing in browser
  top: 0,
  bottom: 0
});

createFromJS.registerCallback("InsetRecord", createFromJS.createPrimitiveCallback(InsetRecord));
